import React, { useEffect } from 'react';
import styles from './styles.module.scss';
import { Button, TextField } from '@mui/material';

import useDigitInput from 'react-digit-input';
import { useState } from 'react';
import className from 'classnames';

import PropTypes from 'prop-types';
import { useTranslation } from '../../../i18n/LanguageProvider';

const DIGIT_COUNT = 5;

const ValidatePhone = ({
  getVerificationCodeAgain,
  onSubmitVerificationCode,
  onCancel,
  phoneNumber,
  loading
}) => {
  const { t } = useTranslation();
  const [value, setValue] = useState('');
  const [time, setTime] = useState(120);
  const digits = useDigitInput({
    acceptedCharacters: /^[0-9]$/,
    length: DIGIT_COUNT,
    value,
    onChange: setValue
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    onSubmitVerificationCode(value);
  };

  useEffect(() => {
    if (phoneNumber.length > 0) {
      const interval = setInterval(() => {
        if (time > 0) setTime(time - 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [time, phoneNumber]);

  return (
    <form onSubmit={handleSubmit}>
      <div>
        <p className={styles.validationDescription}>{t('auth.enterCode')}</p>
        <p
          className={styles.validationDescription}
          style={{ direction: 'ltr' }}
        >
          +{phoneNumber.slice(1)}
        </p>
      </div>
      <div className={className(styles.digitContainer, styles.formItem)}>
        {[...Array(DIGIT_COUNT)].map((_, index) => (
          <TextField
            autocomplete="one-time-code"
            key={index}
            inputProps={{ ...digits[index] }}
            autoFocus={index === 0}
            inputMode="decimal"
            name={'auth-token'}
            hiddenLabel
          />
        ))}
      </div>
      {time > 0 ? (
        <div className={styles.exp}>
          {t('auth.resendIn', {
            time: `${Math.floor(time / 60)}:${time % 60}`
          })}
        </div>
      ) : (
        <Button
          size="small"
          onClick={() => {
            getVerificationCodeAgain(phoneNumber);
            setTime(120);
          }}
        >
          {t('auth.resendCode')}
        </Button>
      )}

      <Button
        fullWidth
        variant="contained"
        className={styles.formItem}
        type="submit"
        disabled={loading}
      >
        {t('common.confirm')}
      </Button>

      <Button
        fullWidth
        variant="outlined"
        className={styles.formItem}
        onClick={onCancel}
        disabled={loading}
      >
        {t('auth.changePhone')}
      </Button>
    </form>
  );
};

ValidatePhone.propTypes = {
  getVerificationCodeAgain: PropTypes.func,
  onSubmitVerificationCode: PropTypes.func,
  onCancel: PropTypes.func,
  phoneNumber: PropTypes.string,
  loading: PropTypes.bool
};

export default ValidatePhone;
